import React from 'react'
import PropTypes from 'prop-types'
import { SmartImage } from 'shared/UI/SmartImage'
import { authorization_email_page_image } from 'common/images/remote/urls.json'
import isEmpty from 'lodash/isEmpty'

import './style.css.scss'

const EmailVerificationImage = (props) => {
  const imageUrl = isEmpty(props.imageUrl) ? authorization_email_page_image : props.imageUrl

  return(
    <div className='by-email-verification-image-box'>
      <SmartImage
        config={{url: imageUrl}}
        className="authorization-page-image"/>
    </div>
  )
}

EmailVerificationImage.propTypes = {
  imageUrl: PropTypes.string
}

export default EmailVerificationImage
